<template>
    <li>
        <a :href="data.link" class="heading-link h6">
            {{ data.title }}
        </a>

        <div class="details xsmall">
            <span class="category">{{ data.type }}</span> |
            {{ dayjs(data.date, 'YYYY-MM-DD').format('MMMM DD, YYYY') }}
        </div>

        <div class="small">
            {{ data.description }}
        </div>
    </li>
</template>

<script>
import dayjs from 'dayjs';

export default {
    props: ['data'],
    computed: {
        pubDate() {
            const date = dayjs(this.data.date);

            return date.format('MMMM d, YYYY');
        },
    },
};
</script>
